<template>
  <ul class="faqs__categories flex overflow-auto">
    <li
      v-for="category in categoriesFiltered"
      :key="category.id"
      class="faqs__category"
    >
      <button
        v-scroll-to="{
          el: `#${category.id}`,
          offset: -130
        }"
        class="faqs__category-btn"
      >
        {{ category.title }}
      </button>
    </li>
  </ul>
</template>

<script>
import { useFaqsStore } from '../pinia/FaqsStore'
import { mapState } from 'pinia'

export default {
  computed: {
    ...mapState(useFaqsStore, [
      'categoriesFiltered'
    ]),
  }
}
</script>
